import { DASH, EMPTY_STRING } from "common/constants";

export enum EVariantExamsHistory {
  SUMMARY = "summary",
  DETAILS = "details"
}

interface IVariantsClassNames {
  detailsClassName: string;
  summaryClassName: string;
}

export const getVariantsClassNames = (
  variant: EVariantExamsHistory
): IVariantsClassNames => {
  return {
    detailsClassName:
      variant === EVariantExamsHistory.DETAILS ? variant : EMPTY_STRING,
    summaryClassName:
      variant === EVariantExamsHistory.SUMMARY ? variant : EMPTY_STRING
  };
};

export const getCodedString = <T>(
  item: T,
  fields: string[] = [],
  shouldShowFullDescription: boolean,
  divider: string = "//"
): string => {
  if (!item) return DASH;

  const selectedFields = [];
  const baseFields = fields.filter(field => field.indexOf("custom") === -1);
  baseFields.forEach(field => {
    const customFieldName = `custom${field[0].toUpperCase()}${field.slice(1)}`;

    if (field === "detailLasixCCs" && !item["detailLasixCCsId"]) {
      return;
    }

    if (item[customFieldName]?.value) {
      selectedFields.push(customFieldName);
    } else {
      selectedFields.push(field);
    }
  });

  const values = selectedFields.map(field => {
    if (field.indexOf("custom") !== -1) {
      return item[field].value;
    }

    if (item[field]) {
      const fullDescription = item[field].description || item[field];
      const shortCodedDescription =
        item[field].shortDescription || fullDescription;

      return shouldShowFullDescription
        ? fullDescription
        : shortCodedDescription;
    }

    return DASH;
  });

  return values.join(divider);
};
